export default "__VITE_ASSET__Dz7_yfQH__"